<template>
  <div>
    <h3 class="om-page-heading">
      <label for="search">{{ $tr('Lista zamówień', 'OrderList') }}</label>
    </h3>
    <form  @submit.prevent="searchAction" class="om-search flex sb">
      <input id="search" v-model="searchValue" class="om-search__input fg-20" :placeholder="$tr('Imię i nazwisko lub numer zamówienia', 'OrderList')" :title="$tr('Imię i nazwisko lub numer zamówienia', 'OrderList')">
      <button type="submit" class="om-btn om-search__submit" :placeholder="$tr('', 'OrderList')" @click.prevent="searchAction">
        {{ $tr('Szukaj', 'OrderList') }}
      </button>
    </form>
    <div class="om-list-heading flex sb">
      <div v-if="pageContent instanceof Array && pageContent.length" class="flex wrap">
        <div class="om-list-heading__label om-list-heading__label--bright">{{ $tr('Wyniki wyszukiwania:', 'OrderList') }}</div>
        <div class="om-list-heading__label">{{ searchValue }}</div>
        <div class="om-list-heading__label om-list-heading__label--num">({{ searchResultsCount }})</div>
      </div>
    </div>

    <table v-if="!noContent" class="om-table">
      <thead>
      <tr>
        <!--<th v-for="column in columns">-->
        <!--{{ column }}-->
        <!--</th>-->
        <th>{{ columns.reference }}</th>
        <th>{{ columns.date }}</th>
        <th>{{ columns.firstname }}</th>
        <th>{{ columns.status }}</th>
        <th>{{ columns.details }}</th>
      </tr>
      </thead>

      <tbody>
      <tr v-for="(item, k) in pageContent" :key="k">
        <td class="reference">{{ item.reference }}</td>
        <td>{{ $moment(item.date).format('DD.MM.YYYY') }}</td>
        <td>
          <div class="font-normal" v-html="highlight(item.firstname + ' ' + item.lastname, search)"></div>
        </td>
        <td class="status" :style="{color: item.statusColor}">{{ item.status }}</td>
        <td class="more">
          <router-link :to="'/admin/order-list/' + item.reference">
            <i class="om-ico-zoom" aria-hidden="true"></i>
          </router-link>
        </td>

      </tr>
      </tbody>

    </table>
    <div v-else-if="typeof request.params.query !== 'undefined' && request.params.query != ''" class="om-information">
      {{ $tr('Brak wyników. Spróbuj zmienić parametry wyszukiwania.', 'OrderList') }}
    </div>
    <div class="om-list-footer flex sb">
      <div></div>
      <paginator
        :items-per-page="currentPerPage"
        v-on:change="updatePageContent"
        v-on:results-count="updateResultsCount"
        :passive-mode="paginatorPassive"
        :request="request"
        :update-force="requestUpdateForce"
        :active="activeListing"></paginator>
    </div>
  </div>
</template>

<script>
  import Paginator from '../reusable/paginator/Paginator.vue'
  import { setTimeout } from 'timers'

  export default {
    components: {Paginator},
    name: 'order-list',
    data () {
      return {
        list: [],
        defaultPerPage: {name: 6, value: 6},
        itemsPerPage: [{name: 6, value: 6}, {name: 12, value: 12}, {name: 24, value: 24}, {name: 48, value: 48}],
        currentPerPage: 6,
        pageContent: [],
        filteredCount: 1,
        searchResultsCount: 0,
        fList: null,
        periodsRadioFilter: null,
        /* table sort functionality */
        sortKey: 'name',

        reverse: false,

        searchValue: '',
        search: '',

        columns: {},
        paginatorPassive: true,
        requestParams: {
          route: 'order',
          params: {}
        },
        requestUpdateForce: 1,
        activeListing: false
      }
    },
    mounted () {
      this.periodsRadioFilter = [
        {value: 'month', name: this.$tr('Miesiąc', 'OrderList')},
        {value: 'week', name: this.$tr('Tydzień', 'OrderList')},
        {value: 'day', name: this.$tr('Dzień', 'OrderList')}
      ]
      this.columns = {
        'reference': this.$tr('Nr zamówienia', 'OrderList'),
        'firstname': this.$tr('Imię i nazwisko', 'OrderList'),
        'data': this.$tr('Dane do przelewu', 'OrderList'),
        'date': this.$tr('Data zamówienia', 'OrderList'),
        'amount': this.$tr('Kwota zwrotu', 'OrderList'),
        'notes': this.$tr('Uwagi', 'OrderList'),
        'status': this.$tr('Status', 'OrderList'),
        'details': this.$tr('Szczegóły', 'OrderList')
      }
      if (this.$store.state.role === 'shop') {
        setTimeout(() => {
          this.activeListing = true
          this.requestUpdateForce++
        }, 400)
        // this.requestParams.params['']
        // this.$http.get(this.$router.options.getApiRoute('order'))
        //   .then((r) => {
        //     this.list = r.body
        //     this.filteredCount = this.list.length
        //     console.log(this.list)
        //   })
      }
    },
    methods: {
      changePerPage (ev) {
        this.currentPerPage = ev
        console.log(ev)
      },
      searchAction () {
        if (this.paginatorPassive) {
          if (this.searchValue !== '') {
            this.requestParams.params['query'] = this.searchValue
            this.activeListing = true
          } else {
            delete this.requestParams.params['query']
            this.activeListing = false
          }
          this.requestUpdateForce++
        } else {
          this.search = this.searchValue
        }
      },
      sortBy (sortKey) {
        this.reverse = (this.sortKey === sortKey) ? !this.reverse : false
        this.sortKey = sortKey
      },
      updatePageContent (content) {
        this.pageContent = content
      },
      highlight (words, query) {
        let iQuery = new RegExp(query, 'ig')
        return words.toString().replace(iQuery, (matchedTxt) => {
          return (`<span class="highlight">${matchedTxt}</span>`)
        })
      },
      updateResultsCount (ev) {
        this.searchResultsCount = ev
      }
    },
    computed: {
      filteredList () {
        let filtered = this.list
        if (this.search !== '') {
          let pattern = new RegExp(this.search, 'i')
          filtered = filtered.filter((item) => {
            return item.firstname.match(pattern) || item.lastname.match(pattern) || item.reference.match(pattern)
          })
        }
        this.filteredCount = filtered.length
        return filtered
      },
      request () {
        return this.requestParams
      },
      noContent () {
        return !(this.pageContent instanceof Array && this.pageContent.length)
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (vm.searchValue) {
          vm.requestUpdateForce++
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../../assets/scss/settings";
  @import "../../assets/scss/utilities";

</style>



// WEBPACK FOOTER //
// OrderList.vue?51fa2840